import React from 'react';

import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import { SSRPlacement as OperationsDiscoverabilitySpotlightPlacement } from '@post-office/placements/operations-overview-discoverability-spotlights/frontend';
import { useIsAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-admin/index.tsx';

type Props = {
	onClick: () => void;
};

/**
 * Renders the spotlight only for JSM/Jira admins.
 * Isolated so the admin hook only runs when the gate is ON.
 */
export const OperationsDiscoverabilitySpotlightForAdmins = ({
	onClick,
}: Props): React.JSX.Element | null => {
	const isAdmin = useIsAdmin();

	if (!isAdmin) {
		return null;
	}

	return (
		<JSErrorBoundary
			id="operations-overview-discoverability-spotlight"
			packageName="jiraNavigationAppsSidebarNav4SidebarsContentCore"
			fallback="unmount"
			teamName="alexstrasza"
		>
			<OperationsDiscoverabilitySpotlightPlacement onClick={onClick} />
		</JSErrorBoundary>
	);
};
